import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Container, Image } from 'react-bootstrap';
import i18n from 'I18n';
import SelectLanguage from './SelectLanguage';
import { ReactComponent as MenuDropdownIcon } from 'assets/images/menu.svg';
import { ReactComponent as MenuDropdownClosedIcon } from 'assets/images/menuClose.svg';
import { getInboxUnreadCount, loginCommonNavItemList, profileNavItemList, unloginCommonNavItemList } from './NavigatorUtils';
import SignupLoginImage from 'assets/images/signup_login.svg';

const SeparateLine = () => {
  return (
    <div className="nav_dropDownMenu_separateLine_container">
      <Container className="nav_dropDownMenu_separateLine">
        <div className="separateLine_color" />
      </Container>
    </div>
  );
};

const SingleNavItem = ({
  navItem,
  messageUnreadCount,
  setSideMenuDropdownOpen,
}) => {
  const history = useHistory();

  const linkOnClick = (pathname) => {
    history.push(pathname);
    setSideMenuDropdownOpen(false);
  }

  return (
    <div
      key={`side-menu-${navItem.name}`}
      className="nav_dropDownMenu_item_container"
      onClick={() => linkOnClick(navItem.linkTo)}
    >
      <Container className="nav_dropDownMenu_item">
        <Image
          className="dropDownItem_image"
          src={navItem.imageUrl}
          srcSet={navItem.srcSet}
        />
        <div className="dropDownItem_text field-text">
          {i18n.t(navItem.name)}
          {navItem.name === 'home_inbox' && getInboxUnreadCount(messageUnreadCount)}
        </div>
      </Container>
    </div>
  )
}

const CommonNavItems = ({
  isMobile,
  navBarConfig,
  isLogin,
  messageUnreadCount,
  setSideMenuDropdownOpen,
}) => {
  const commonItemsData = isLogin ? loginCommonNavItemList : unloginCommonNavItemList;

  if (!isMobile && navBarConfig.webShowSections) {
    return null;
  };

  return (
    <>
      {commonItemsData.map((data, index) => (
        <SingleNavItem
          navItem={data}
          messageUnreadCount={messageUnreadCount}
          setSideMenuDropdownOpen={setSideMenuDropdownOpen}
        />
      ))}
    </>
  );
};

const ProfileNavItems = ({
  isMobile,
  isLogin,
  navBarConfig,
  messageUnreadCount,
  setSideMenuDropdownOpen,
}) => {
  const showSeparateLine = isMobile ||
    (!isMobile && !navBarConfig.webShowSections);

  if (!isLogin) {
    return null;
  };

  return (
    <>
      {showSeparateLine && (
        <SeparateLine />
      )}
      {profileNavItemList.map((data, index) => (
        <SingleNavItem
          navItem={data}
          messageUnreadCount={messageUnreadCount}
          setSideMenuDropdownOpen={setSideMenuDropdownOpen}
        />
      ))}
    </>
  );
};

const SignInSection = ({
  isLogin,
  isOpenInOtherSite,
  loginOnClick,
}) => {
  if (isLogin) {
    return null;
  };

  return (
    <div className="mobile-signup-login-area">
      <img className="signup-login-logo" alt="" src={'/logo/profile_logo_image.png'} />
      {!isOpenInOtherSite && (
        <div className="signup-login-button-area">
          <button className='button-large' onClick={loginOnClick}>
            {i18n.t('profile_get_started_sign_up_or_log_in')}
          </button>
        </div>
      )}
    </div>
  )
}

const SignOutSection = ({
  isLogin,
  isOpenInOtherSite,
  logoutOnClick,
}) => {
  if (!isLogin) {
    return null;
  };

  if (isOpenInOtherSite) {
    return null;
  };

  return (
    <>
      <SeparateLine />
      <div className="nav_dropDownMenu_item_container">
        <Container
          className="nav_dropDownMenu_item"
          onClick={logoutOnClick}
        >
          <div className="dropDownItem_text field-text">
            {i18n.t('account_logout')}
          </div>
        </Container>
      </div>
    </>
  );
}


const MobileRightComponent = ({
  language,
  isLogin,
  isOpenInOtherSite,
  messageUnreadCount,
  navBarConfig,
  languageDropdownOpen,
  setLanguageDropdownOpen,
  sideMenuDropdownOpen,
  setSideMenuDropdownOpen,
  loginOnClick,
  logoutOnClick,
}) => {

  return (
    <div className='mobile-header-right-component'>
      <div className='mobile-header-right-section'>
        {
          navBarConfig.mobileShowLanguage && (
            <SelectLanguage
              languageDropdownOpen={languageDropdownOpen}
              setLanguageDropdownOpen={setLanguageDropdownOpen}
              setSideMenuDropdownOpen={setSideMenuDropdownOpen}
            />
          )
        }

        {
          sideMenuDropdownOpen
            ? <MenuDropdownClosedIcon
              className="header-right-dropdown-image"
              onClick={() => { setSideMenuDropdownOpen(!sideMenuDropdownOpen) }}
            />
            : <MenuDropdownIcon
              className="header-right-dropdown-image"
              onClick={() => { setSideMenuDropdownOpen(!sideMenuDropdownOpen) }}
            />
        }
      </div>

      <div
        className="nav_mobile_dropDownMenu"
        style={{ display: sideMenuDropdownOpen ? 'flex' : 'none' }}
      >
        <div className="nav_dropDownMenu_content field-text">
          <SignInSection
            isLogin={isLogin}
            isOpenInOtherSite={isOpenInOtherSite}
            loginOnClick={loginOnClick}
          />

          {
            !navBarConfig.mobileShowLanguage && (
              <SelectLanguage
                languageDropdownOpen={languageDropdownOpen}
                setLanguageDropdownOpen={setLanguageDropdownOpen}
              />
            )
          }

          <CommonNavItems
            isMobile={true}
            navBarConfig={navBarConfig}
            isLogin={isLogin}
            messageUnreadCount={messageUnreadCount}
            setSideMenuDropdownOpen={setSideMenuDropdownOpen}
          />
          <ProfileNavItems
            isMobile={true}
            isLogin={isLogin}
            navBarConfig={navBarConfig}
            messageUnreadCount={messageUnreadCount}
            setSideMenuDropdownOpen={setSideMenuDropdownOpen}
          />

          <SignOutSection
            isLogin={isLogin}
            isOpenInOtherSite={isOpenInOtherSite}
            logoutOnClick={logoutOnClick}
          />
        </div>
      </div>
    </div>
  )
}


const WebLoginSection = ({
  isLogin,
  displayName,
  isOpenInOtherSite,
  navBarConfig,
  sideMenuDropdownOpen,
  setSideMenuDropdownOpen,
  setLanguageDropdownOpen,
  loginOnClick,
}) => {
  const clickSideMenu = () => {
    setSideMenuDropdownOpen(!sideMenuDropdownOpen);
    setLanguageDropdownOpen(false);
  }

  if (!isLogin && isOpenInOtherSite) {
    return null;
  };

  if (!isLogin && navBarConfig.webShowSections) {
    return (
      <div
        className="nav_btn signup"
        onClick={loginOnClick}
      >
        {i18n.t('sign_up_login')}
      </div>
    )
  }

  if (!isLogin) {
    return (
      <>
        <div
          className="nav_btn signup"
          onClick={loginOnClick}
        >
          {i18n.t('sign_up_login')}
        </div>
        <MenuDropdownIcon
          className="header-right-dropdown-image"
          onClick={clickSideMenu}
        />
      </>
    )
  }

  if (navBarConfig.webShowSideMenu) {
    return (
      <MenuDropdownIcon
        className="header-right-dropdown-image"
        onClick={clickSideMenu}
      />
    )
  }

  return (
    <div className="nav_div" onMouseEnter={clickSideMenu}>
      {i18n.t('home_hello') + ', ' + displayName}
    </div>
  )
}

const WebRightComponent = ({
  language,
  isLogin,
  displayName,
  isOpenInOtherSite,
  messageUnreadCount,
  navBarConfig,
  languageDropdownOpen,
  setLanguageDropdownOpen,
  sideMenuDropdownOpen,
  setSideMenuDropdownOpen,
  loginOnClick,
  logoutOnClick,
}) => {
  const webRef = useRef();
  const navShowLanguage = navBarConfig.webShowLanguage;
  const sideMenuShowLanguage = navBarConfig.webShowSideMenu && !navBarConfig.webShowLanguage;

  const handleClickOutside = (event) => {
    if (webRef.current && !webRef.current.contains(event.target)) {
      setSideMenuDropdownOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={webRef}
      className='web-header-right-component'
    >
      <div className='web-header-right-login-and-language'>
        <WebLoginSection
          isLogin={isLogin}
          displayName={displayName}
          isOpenInOtherSite={isOpenInOtherSite}
          navBarConfig={navBarConfig}
          sideMenuDropdownOpen={sideMenuDropdownOpen}
          setSideMenuDropdownOpen={setSideMenuDropdownOpen}
          setLanguageDropdownOpen={setLanguageDropdownOpen}
          loginOnClick={loginOnClick}
        />

        {
          navShowLanguage && (
            <SelectLanguage
              languageDropdownOpen={languageDropdownOpen}
              setLanguageDropdownOpen={setLanguageDropdownOpen}
              setSideMenuDropdownOpen={setSideMenuDropdownOpen}
              extraSeparateLine
            />
          )
        }
      </div>

      <div
        className="nav_web_dropDownMenu field-text"
        style={{ display: sideMenuDropdownOpen ? 'flex' : 'none' }}
      >
        <div className="nav_dropDownMenu_content">

          {
            isLogin && navBarConfig.webShowSideMenu && (
              <div className="nav_web_dropDownMenu_name" >
                <div className='nav_web_dropDownMenu_name_text subheading'>
                  {i18n.t('home_hello') + ', ' + displayName}
                </div>
              </div>
            )
          }

          {
            sideMenuShowLanguage && (
              <SelectLanguage
                languageDropdownOpen={languageDropdownOpen}
                setLanguageDropdownOpen={setLanguageDropdownOpen}
              />
            )
          }

          <CommonNavItems
            isMobile={false}
            navBarConfig={navBarConfig}
            isLogin={isLogin}
            messageUnreadCount={messageUnreadCount}
            setSideMenuDropdownOpen={setSideMenuDropdownOpen}
          />
          <ProfileNavItems
            isMobile={false}
            isLogin={isLogin}
            navBarConfig={navBarConfig}
            messageUnreadCount={messageUnreadCount}
            setSideMenuDropdownOpen={setSideMenuDropdownOpen}
          />

          <SignOutSection
            isLogin={isLogin}
            isOpenInOtherSite={isOpenInOtherSite}
            logoutOnClick={logoutOnClick}
          />
        </div>
      </div>
    </div>
  )
};


const RightComponent = ({
  language,
  isLogin,
  displayName,
  isOpenInOtherSite,
  messageUnreadCount,
  navBarConfig,
  isMobile,
  loginOnClick,
  logoutOnClick,
}) => {
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [sideMenuDropdownOpen, setSideMenuDropdownOpen] = useState(false);

  if (isMobile) {
    return (
      <MobileRightComponent
        language={language}
        isLogin={isLogin}
        isOpenInOtherSite={isOpenInOtherSite}
        messageUnreadCount={messageUnreadCount}
        navBarConfig={navBarConfig}
        languageDropdownOpen={languageDropdownOpen}
        setLanguageDropdownOpen={setLanguageDropdownOpen}
        sideMenuDropdownOpen={sideMenuDropdownOpen}
        setSideMenuDropdownOpen={setSideMenuDropdownOpen}
        loginOnClick={loginOnClick}
        logoutOnClick={logoutOnClick}
      />
    )
  }

  return (
    <WebRightComponent
      language={language}
      isLogin={isLogin}
      displayName={displayName}
      isOpenInOtherSite={isOpenInOtherSite}
      messageUnreadCount={messageUnreadCount}
      navBarConfig={navBarConfig}
      languageDropdownOpen={languageDropdownOpen}
      setLanguageDropdownOpen={setLanguageDropdownOpen}
      sideMenuDropdownOpen={sideMenuDropdownOpen}
      setSideMenuDropdownOpen={setSideMenuDropdownOpen}
      loginOnClick={loginOnClick}
      logoutOnClick={logoutOnClick}
    />
  )
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  displayName: state.users.displayName,
  isOpenInOtherSite: state.users.isOpenInOtherSite,
  messageUnreadCount: state.inboxMessages.unReadCount,
});

export default connect(mapStateToProps)(RightComponent);
